import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ProcessTask,
  ProcessTaskDetail
} from './workflow-api.service';
import { WorkflowTaskOperations } from '../../shared/workflow-surfaces/workflow-task-operations';

@Injectable({ providedIn: 'root' })
export class OrganizationWorkflowApiService implements WorkflowTaskOperations {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/workflow`;

  getInbox(): Observable<ProcessTask[]> {
    return this.http.get<ProcessTask[]>(`${this.base}/tasks/inbox`);
  }

  getTask(id: string): Observable<ProcessTaskDetail> {
    return this.http.get<ProcessTaskDetail>(`${this.base}/tasks/${id}`);
  }

  claimTask(id: string): Observable<ProcessTask> {
    return this.http.post<ProcessTask>(`${this.base}/tasks/${id}/claim`, null);
  }

  saveTaskFormData(id: string, formDataJson: string): Observable<ProcessTask> {
    return this.http.put<ProcessTask>(`${this.base}/tasks/${id}/form-data`, { formDataJson });
  }

  completeTask(id: string, outputDataJson: string): Observable<ProcessTask> {
    return this.http.post<ProcessTask>(`${this.base}/tasks/${id}/complete`, { outputDataJson });
  }

  delegateTask(id: string, toUserId: string, reason: string): Observable<ProcessTask> {
    return this.http.post<ProcessTask>(`${this.base}/tasks/${id}/delegate`, { toUserId, reason });
  }

  escalateTask(id: string, targetUserId: string | undefined, reason: string): Observable<ProcessTask> {
    return this.http.post<ProcessTask>(`${this.base}/tasks/${id}/escalate`, {
      targetUserId: targetUserId || null,
      reason: reason || null
    });
  }

  addComment(id: string, body: string): Observable<unknown> {
    return this.http.post(`${this.base}/tasks/${id}/comments`, { body });
  }
}
